export default __webpack_public_path__ + "static/media/historicaR.c0210b0c.png";